{
  "id": "campaign-006",
  "name": "Breezy Field",
  "seed": "campaign:6",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "..._....",
    "..._....",
    "**._....",
    "..._..#.",
    "..._....",
    "#.._....",
    "..._..B.",
    "........",
    ".......S"
  ],
  "critters": [],
  "pickups": [
    {
      "kind": "coin",
      "x": 3,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 2
    }
  ],
  "generatorVersion": 3,
  "level": 6,
  "biome": "backyard",
  "par": {
    "reel": 2070,
    "push": 1742,
    "selfPropelled": 1608,
    "tractor": 1380,
    "zeroTurn": 1139,
    "fairway": 704
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 18,
      "selfPropelled": 18,
      "tractor": 21,
      "zeroTurn": 20,
      "fairway": 4
    }
  }
}
